(function (Drupal, drupalSettings) {
  Drupal.behaviors.medecin = {
    attach: function (context, settings) {
      const medecinPage = context.querySelector(".page-node-type-medecin");
      if (medecinPage && !medecinPage.dataset.medecinProcessed) {
        medecinPage.dataset.medecinProcessed = "true";

        const breadcrumbOl = context.querySelector(".breadcrumb ol");
        const breadcrumbTarget = context.querySelector(".js-breadcrumb");

        if (breadcrumbOl && breadcrumbTarget) {
          breadcrumbTarget.appendChild(breadcrumbOl);
        }
      }
    },
  };
})(Drupal, drupalSettings);
